import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

const MetricsDashboard = ({ metrics }) => {
  return (
    <section id="metrics" className="relative py-24 sm:py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4"
        >
          Core Metrics Tracked
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-none mb-16 max-w-2xl"
        >
          Every decision is measured. No vanity metrics.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {metrics.map((m, i) => (
            <motion.div
              key={m.key}
              data-testid={HOME.metricCard(m.key)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="glass-panel rounded-2xl p-6 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="font-display text-sm font-bold text-white mb-2">{m.label}</div>
              <div className="text-sm text-white/50 leading-relaxed">{m.detail}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsDashboard;
